import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReAuth } from "@/store/api/baseQueryWithReAuth"
import {useSelector} from "react-redux";
import {RootState} from "@/store";
import {Company} from "@/store/api/companyApi";

export interface Shareholder {
    id: number;
    first_name: string;
    last_name: string;
    residential_address: string;
    date_of_birth: string;
    ownership: number;
}

export const shareholderApi = createApi({
    reducerPath: "shareholderApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getShareholder: builder.query<Shareholder[], number>({
            query: (companyID) => `/client-shareholder/${companyID}`
        })
    })
})

export const { useGetShareholderQuery } = shareholderApi;